import PasswordUpdater from './PasswordUpdater'

export default PasswordUpdater
